<template>
  <div>
    <List
      url="device-security/auth-tool/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="confirmDelete"
      @setting="confirmReset"
    >

      <div slot="Filter">
        <el-row :gutter="20">
          <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
            <label>生成新用户和密码: </label>
            <el-input
              v-model="newUserName"
              size="small"
              style="width:400px;margin-right:10px;"
              placeholder="请输入用户名（如果为空, 随机生成用户名）"
            ></el-input>
            <el-input
              v-model="newUserDesc"
              size="small"
              style="width:200px;margin-right:10px;"
              placeholder="请输入备注（可以为空）"
            ></el-input>
            <el-button @click="onCreate" type="primary" size="small">创建</el-button>
          </el-col>
        </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <el-input
          v-model="searchData.user"
          @change="search"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="搜索用户名称"
        ></el-input>
        <el-input
          v-model="searchData.operator"
          @change="search"
          size="small"
          style="width:200px;margin-right:10px;"
          placeholder="搜索操作人"
        ></el-input>
        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>
    </List>

    <AuthToolUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></AuthToolUpdateBox>

    <el-dialog title="新用户名和密码" width="500px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      >
      <div>
        <el-alert
          title="用户密码只会显示一次，请复制保存"
          type="warning"
          show-icon
          :closable="false"
        ></el-alert>
        <p style="margin-top:30px;">
          <strong>用户名:</strong> {{ newUserData.user }}
          <el-tooltip effect="dark" content="复制用户名" placement="top">
            <el-button type="text" icon="el-icon-document-copy" @click="copyToClipboard(newUserData.user)"></el-button>
          </el-tooltip>
        </p>
        <p>
          <strong>密码:</strong> {{ newUserData.passwd }}
          <el-tooltip effect="dark" content="复制密码" placement="top">
            <el-button type="text" icon="el-icon-document-copy" @click="copyToClipboard(newUserData.passwd)"></el-button>
          </el-tooltip>
        </p>
        <p><strong>备注:</strong> {{ newUserData.desc }}</p>
      </div>
      <span slot="footer">
        <el-button @click=handleClose>关闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="确认重置密码"
      :visible.sync="ResetDialogVisible"
      width="30%"
      @close="cancelReset"
    >
      <el-alert
        title="重置密码前，请确保没有客户在用这个账号，否则将导致客户投诉。"
        type="warning"
        show-icon
        :closable="false"
      ></el-alert>
      <span style="display: block;margin-top:30px;">您确定要重置用户 {{ selectedUser.user }} 的密码吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelReset">取消</el-button>
        <el-button type="primary" @click="resetPasswd">确认</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="确认删除"
      :visible.sync="DeleteDialogVisible"
      width="30%"
      @close="cancelDelete"
    >
      <el-alert
        title="删除用户前，请确保没有客户在用这个账号，否则将导致客户投诉。"
        type="warning"
        show-icon
        :closable="false"
      ></el-alert>
      <span style="display: block;margin-top:30px;">您确定要删除用户 {{ selectedUser.user }} 吗？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDelete">取消</el-button>
        <el-button type="primary" @click="deletedata">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import List from "../components/common/List.vue";
import AuthToolUpdateBox from "../components/DeviceSecurity/AuthToolUpdateBox.vue";

export default {
  components: {
    List,
    AuthToolUpdateBox
  },
  data() {
    return {
      dialogVisible: false,
      ResetDialogVisible: false,
      DeleteDialogVisible: false,
      newUserData: {},
      newUserName: "",
      newUserDesc: "",
      selectedUser: {},
      title: "设备安全密码",
      tanle: [
        { name: "user", label: "用户名" },
        { name: "desc", label: "备注" },
        { name: "operator", label: "操作人" }
      ],

      searchData: {
        user: "",
        operator: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Setting",
          eventName: "setting"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    search() {
      this.updateList++;
    },
    deletedata() {
      let url = "device-security/auth-tool/" + this.selectedUser.id + "/";
      this.DeleteDialogVisible = false;
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    handleClose () {
        this.newUserData = {};
        this.dialogVisible = false;
        this.updateList++;
    },
    onCreate() {
      this.$http["post"](
        "device-security/auth-tool/",
        {user: this.newUserName, desc: this.newUserDesc},
        (res) => {
          this.newUserData = res.data;
          this.dialogVisible = true;
          this.$message.success(res.msg);
        }
      );
    },
    copyToClipboard(text) {
      const input = document.createElement('input');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      } catch (err) {
        this.$message({
          message: '复制失败',
          type: 'error'
        });
      }
      document.body.removeChild(input);
    },
    confirmDelete(val) {
      this.selectedUser = val;
      this.DeleteDialogVisible = true;
    },
    cancelDelete() {
      this.DeleteDialogVisible = false;
    },
    confirmReset(val) {
      this.selectedUser = val;
      this.ResetDialogVisible = true;
    },
    cancelReset() {
      this.ResetDialogVisible = false;
    },
    resetPasswd() {
      let url = "device-security/auth-tool/" + this.selectedUser.id + "/";
      this.ResetDialogVisible = false;
      this.$http["post"](
        url,
        {operation: "resetPasswd"},
        (res) => {
          this.newUserData = res.data;
          this.dialogVisible = true;
          this.$message.success(res.msg);
        });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
